import 'css-chunksrc/client/scenes/transferProjectResourceAllocations/styles.scss';export default {
  "warning": "_warning_18a71_1",
  "group": "_group_18a71_7",
  "toggle": "_toggle_18a71_11",
  "text": "_text_18a71_24",
  "name": "_name_18a71_30",
  "main": "_main_18a71_36",
  "allocationWrapper": "_allocationWrapper_18a71_43",
  "openedInput": "_openedInput_18a71_48",
  "input": "_input_18a71_48",
  "quickAllocationMenu": "_quickAllocationMenu_18a71_54",
  "toggleIcon": "_toggleIcon_18a71_83",
  "resourceAvatar": "_resourceAvatar_18a71_89",
  "content": "_content_18a71_94",
  "buttons": "_buttons_18a71_101",
  "button": "_button_18a71_101",
  "listsContainer": "_listsContainer_18a71_116",
  "selectAll": "_selectAll_18a71_124",
  "checkbox": "_checkbox_18a71_130",
  "noTasks": "_noTasks_18a71_135"
};